import { render } from "./BlogPostCategories.vue?vue&type=template&id=611b87bc"
import script from "./BlogPostCategories.vue?vue&type=script&lang=js"
export * from "./BlogPostCategories.vue?vue&type=script&lang=js"

import "./BlogPostCategories.vue?vue&type=style&index=0&id=611b87bc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__